// extracted by mini-css-extract-plugin
module.exports = {"suppress_relationships":"SuppressRelationships_suppress_relationships__1N_A1"};